var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#CFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 6.23861C13.5713 6.05986 11.7567 5.96777 9.9475 5.96777C8.875 5.96777 7.8025 6.02194 6.73 6.13027L5.625 6.23861",
    stroke: "#878787",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60156 5.69078L8.72073 4.9812C8.8074 4.46661 8.8724 4.08203 9.78781 4.08203H11.207C12.1224 4.08203 12.1928 4.48828 12.2741 4.98661L12.3932 5.69078",
    stroke: "#878787",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2099 7.95117L13.8578 13.4058C13.7982 14.2562 13.7495 14.917 12.2382 14.917H8.76073C7.24948 14.917 7.20073 14.2562 7.14115 13.4058L6.78906 7.95117",
    stroke: "#878787",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 11.9375H11.3975",
    stroke: "#878787",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14844 9.76953H11.8568",
    stroke: "#878787",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBordered);
export default __webpack_public_path__ + "static/media/delete_bordered.27d1e2c3fbd7509751f787052351701a.svg";
export { ForwardRef as ReactComponent };